import { t } from "@lingui/macro";

import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { SlotPricingPreview } from "../types";

export const formatSlotPricingPreview = (
  preview: SlotPricingPreview | undefined,
  currencySymbol: string
): string | null => {
  if (preview?.amount == null || !Number.isFinite(preview.amount)) {
    return null;
  }

  const price = `${currencySymbol}${ConvertCentsToDollars(preview.amount)}`;
  switch (preview.mode) {
    case "HOURLY":
      return t`${price}/hr`;
    case "STARTING_AT":
      return t`Starting at ${price}`;
    default:
      return null;
  }
};
